import React from "react";
import GingerBreadMan from "../assets/2024/recipes/MUNECO-DE-DULCE.png";
import MunecoNieve from "../assets/2024/recipes/MUNECO-DE-NIEVE.png";
import nieve from "../assets/2024/recipes/NIEVE-FONDO.png";
import flavour from "../assets/2024/recipes/SABOR-QUE-TE-ACERCA-A-LA-NAVIDAD.png";
import flavourEng from "../assets/2024/recipes/SABOR-QUE-TE-ACERCA.INGLES.png";
import sorpresa from "../assets/2024/recipes/SORPRENDE-A-TUS-SERES-QUERIDOS.png";
import sorpresaEng from "../assets/2024/recipes/SOPRENDE-A-TUS-SERES-INGLES.png";

import { Col, Container, Row } from "react-bootstrap";
import { VideoView } from "../components/components/videoView";
import { useIntl } from "react-intl";
export const Recipes = () => {
  const intl = useIntl();

  const videoList = [
    {
      url: "O_k3Mxv-yhk?si=dXzu-kIYbjusDt_7",
    },
    {
      url: "O_k3Mxv-yhk?si=dXzu-kIYbjusDt_7",
    },
    {
      url: "O_k3Mxv-yhk?si=dXzu-kIYbjusDt_7",
    },
  ];

  return (
    <div className="recipes__background">
      <img src={nieve} alr="Imagen fondo nieve" className="sectionBg__nieve" />
      <img
        src={MunecoNieve}
        className=" sectionBg__munecoNieve"
        alt="logo"
      ></img>
      <img
        src={GingerBreadMan}
        className="sectionBg__gingerBreadMan"
        alt="logo"
      ></img>
      <Container className="recipes__margin">
        <Row className="mt-5">
          <Col xs={12}>
            <img
              src={intl.locale.includes("es") ? flavour : flavourEng}
              className="recipes__welcome"
            ></img>
          </Col>
          <Col xs={12} className="mt-3">
            <img
              src={intl.locale.includes("es") ? sorpresa : sorpresaEng}
              className="recipes__sorpresa"
            ></img>
          </Col>
          <Col xs={12} className="mt-5">
            <VideoView videoList={videoList} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
